import {TFunction} from 'i18next';
import {RowData} from '../../base/export-care-plan-group-data-processor';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonIadlPdfDataProcessor} from '../export-care-plan-common-iadl-pdf-data';

export class HousekeepingPdfDataProcessor extends CommonIadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.handleTaskDetailsCellValue = (rowData: RowData) => {
      // TODO: We should get by feature.
      const housekeepingEntry = rowData.getEntryById('64dece192a52458ff55deaf0');
      const housekeepingName = `<b>${housekeepingEntry?.name ?? 'n/a'}:</b>`;
      const housekeepingValue = this.getEntryValue(housekeepingEntry);

      return `${housekeepingName}\n${housekeepingValue}`;
    };
  }
}
